import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=64386ce6&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=64386ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64386ce6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64386ce6')) {
      api.createRecord('64386ce6', component.options)
    } else {
      api.reload('64386ce6', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=64386ce6&scoped=true&", function () {
      api.rerender('64386ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/SettingRenew/Menu.vue"
export default component.exports